import React, { useEffect } from 'react';
import { useAuth } from '../contextos/AuthProvider'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { EncApi, EncabezadoPost, LasMonedas, OpcionesExportacion, SiNo, SiNoNum } from '../Comunes/Listas';

const MisDatos = () => {
    const navigate = useNavigate();
    const { PerfilUsuario , Token } = useAuth();
    const handleOnSubmit = async (e) => {

        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };
    const [Gestor, setGestor] = React.useState({
        MONEDA_PREDILECTA: 'CRC',
        SERVICIO_INCLUIDO: '0',
        AUTO_REPORTES: 'N',
        CORREO_CONTADOR: '',
        DIAS: '5',
        FORMATO: 'P',
    });
    const Modificar = (e) => {
        const { name, value } = e.target;
        setGestor((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const [Cripto, setCripto] = React.useState({
        RutaLlave: '',
        PIN: '',
        UsuarioToken: '',
        ClaveToken: '',
    });
    const ModificaCripto = (e) => {
        const { name, value } = e.target;
        setCripto((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const Salir = () => {
        navigate("/");
    }


    const GuardarPreferencias = async () => {
        Swal.fire({
            title: '¿Está seguro?',
            text: "¿Desea guardar las preferencias?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, guardar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    console.log(JSON.stringify(Gestor));
                    const response = await fetch('https://smartfecr.com:2020/SmartContrackBack/api/SmartFeCr/GuardarConfiguracion', EncabezadoPost(Token,Gestor));
                    const data = await response.json();
                    console.log(data);
                    if (data.Codigo === 0) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Resultado:',
                            text: 'Preferencias guardadas correctamente',
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Alerta',
                            text: data.Mensaje,
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Alerta',
                        text: error.message,
                    });
                }
            }
        });

    };
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const fileContent = e.target.result;
                // Aquí puedes hacer algo con el contenido del archivo, como guardarlo en el estado o enviarlo a un servidor
                console.log(fileContent);
            };
            reader.readAsText(file); // Cambia a readAsDataURL si necesitas un enlace de datos
        }
    };


    useEffect(() => {
        const fetchGestor = async () => {
            try {
                const response = await fetch('https://smartfecr.com:2020/SmartContrackBack/api/SmartFeCr/ObtenerConfiguracion?IdCia=' + PerfilUsuario.IdCia, EncApi(Token));
                const data = await response.json();

                let Gest = data.Datos.configuracion[0];
                Gest.CONTRATO = PerfilUsuario.IdCia;
                //console.log(Gest);
                setGestor(Gest);

                setCripto(data.Datos.Hacienda);
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Alerta',
                    text: error.message,
                });
            }
        };
        if (PerfilUsuario) {
            fetchGestor();
        }
        // eslint-disable-next-line
    }, []);

    if (Cripto && Gestor && PerfilUsuario) {
        return (
            <div className='main-block'>
                <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                    <div className='formadoShadow'>

                        <div className='tituloPantalla'>
                            <p style={{ display: 'inline-block' }}> Notas de Débito</p>
                            <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                        </div>

                        <div className='row'>
                            <div className='col-50'>
                                <h3>Preferencias Generales</h3>

                                <div className="row">
                                    <div className='col-50'>
                                        <span className="col-form-span">Moneda Preferida </span>
                                        <select id="MONEDA_PREDILECTA" name="MONEDA_PREDILECTA" className="form-group"
                                            onChange={Modificar} value={Gestor.MONEDA_PREDILECTA}>
                                            {LasMonedas.map((option, i) => (
                                                <option key={i} value={option.value}>{option.span}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='col-50'>
                                        <span className="col-form-span"> ¿10% Cargado en el precio? </span>
                                        <select id="MONEDA_PREDILECTA" name="MONEDA_PREDILECTA" className="form-group"
                                            onChange={Modificar} value={Gestor.MONEDA_PREDILECTA}>
                                            {SiNoNum.map((option, i) => (
                                                <option key={i} value={option.value}>{option.span}</option>
                                            ))}
                                        </select>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className='col-50'>
                                        <span className="col-form-span"> Envío automático de reportes al correo </span>
                                        <select id="AUTO_REPORTES" name="AUTO_REPORTES" className="form-group"
                                            onChange={Modificar} value={Gestor.AUTO_REPORTES}>
                                            {SiNo.map((option, i) => (
                                                <option key={i} value={option.value}>{option.span}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='col-50'>
                                        <span className="col-form-span">Correo Destino </span>
                                        <input type="text" id="CORREO_CONTADOR" name="CORREO_CONTADOR" onChange={Modificar} autoComplete='off'
                                            value={Gestor.CORREO_CONTADOR}></input>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className='col-50'>
                                        <span className="col-form-span">Días Reporte </span>
                                        <input type="text" id="DIAS" name="DIAS" autoComplete='off'
                                            value={Gestor.DIAS} onChange={Modificar}></input>
                                    </div>
                                    <div className='col-50'>
                                        <span className="col-form-span"> Formato deseado </span>
                                        <select id="FORMATO" name="FORMATO" className="form-group"
                                            onChange={Modificar} value={Gestor.FORMATO}>
                                            {OpcionesExportacion.map((option, i) => (
                                                <option key={i} value={option.value}>{option.text}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>


                                <div className='row'>
                                    <div className='col-25'>
                                        <button onClick={() => GuardarPreferencias()} >Guardar</button>
                                    </div>
                                    <div className='col-75'>
                                    </div>

                                </div>
                            </div>


                            <div className='col-50'>
                                <h3>Llave Criptográfica</h3>
                                <div className='row'>
                                    <div className='col-25'>
                                        <span className="col-form-span" >Su llave Actual vence:</span>

                                        <input type="date" id="VencimientoCert" value={Cripto.VencimientoCert ? Cripto.VencimientoCert.split('T')[0] : ''} name="VencimientoCert" disabled onChange={ModificaCripto} />

                                    </div>
                                    <div className='col-75'>
                                        </div>
                            

                                </div>
                                <div className='row'>
                                    <div className='col-75'>
                                        <span className="col-form-span" >Ruta Llave</span>

                                        <input type="file" id="fileUpload" name="fileUpload" accept=".p12" onChange={handleFileUpload} />
                                    </div>
                                    <div className='col-25'>
                                        <span className="col-form-span" >PIN </span>
                                        <input type="text" id="PIN" name="PIN" autoComplete='off' value={Cripto.PIN} onChange={ModificaCripto}></input>
                                    </div>

                                </div>
                                <div className='row'>
                                    <div className='col-50'>
                                        <button onClick={() => GuardarPreferencias()} >Subir llave</button>
                                    </div>
                                    <div className='col-50'>
                                    </div>

                                </div>
                                <h3>Usuario Producción ATV</h3>
                                <div className='row'>
                                    <div className='col-75'>
                                        <span className="col-form-span" >Usuario Token</span>
                                        <input type="text" id="UsuarioToken" name="UsuarioToken" autoComplete='off' value={Cripto.UsuarioToken} onChange={ModificaCripto}></input>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-75'>
                                        <span className="col-form-span" >Clave Token </span>
                                        <input type="text" id="ClaveToken" name="ClaveToken" autoComplete='off' value={Cripto.ClaveToken} onChange={ModificaCripto}></input>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f9f9f9',
                fontFamily: 'Arial, sans-serif',
                color: '#555',
                textAlign: 'center'
            }}>
                <div>
                    <p style={{
                        fontSize: '18px',
                        marginBottom: '10px'
                    }}>Cargando Información...</p>
                    <p style={{
                        fontSize: '14px',
                        color: '#888'
                    }}>Por favor, espere mientras se cargan los datos necesarios.</p>
                </div>
            </div>
        );
    }
};

export default MisDatos;